<template>
    <footer id="footer">
            <div class="container">
                <div class="footer-ribbon">
                    <span>Get in Touch</span>
                </div>
                <div class="row py-5 mt-4">
                    <div class="col-md-6 col-lg-3 mb-4 mb-md-0">
                        <div class="contact-details">
                            <h5 class="text-5 mb-3">CONTACT US</h5>
                            <ul class="list list-icons list-icons-lg text-4">
                                <li class="mb-1"><i class="far fa-envelope text-color-primary"></i><p class="m-0"><a href="mailto:kontakt@codedive.pl">kontakt@codedive.pl</a></p></li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-3 mb-4">
                        <h5 class="text-5 mb-3">FOLLOW US</h5>
                        <ul class="social-icons">
                            <li class="social-icons-facebook"><a href="https://www.facebook.com/CodeDiveWroclaw/" target="_blank" title="Facebook"><img alt="Facebook" :src="require('../assets/img/facebook.svg')"></a></li>
                            <li class="social-icons-twitter"><a href="https://twitter.com/code_dive_pl" target="_blank" title="Twitter"><img alt="Twitter" :src="require('../assets/img/twitter.svg')"></a></li>
                            <li class="social-icons-youtube"><a href="https://www.youtube.com/channel/UCU0Rt8VHO5-YNQXwIjkf-1g/featured" target="_blank" title="youtube"><img alt="youtube" :src="require('../assets/img/youtube.svg')"></a></li>
                        </ul>
                    </div>
                    <div class="col-md-6 col-lg-4 mb-4 mb-lg-0">
                        <h5 class="text-5 mb-3">code::dive</h5>
                        <p class="pr-1 text-4">© Copyright 2014-2021 by code::dive. All rights reserved.</p>
                    </div>
                    <div class="col-md-6 col-lg-2 mb-4 mb-lg-0">
                        <a href="https://nokiawroclaw.pl/" target="_blank"><img alt="Brought to you by NOKIA" width="210" :src="require('../assets/img/nokia.svg')"></a>
                    </div>
                </div>
            </div>
        </footer>
</template>

<script>
export default {
    name: 'Footer'
}
</script>

<style lang="scss">
    @import '@/assets/sass/variables.scss';

    #footer{
        .social-icons-facebook{
            img{
                width: 13px;
                height: 17px;
                filter: invert(15%) sepia(54%) saturate(3654%) hue-rotate(210deg) brightness(98%) contrast(89%);
            }
        }
        .social-icons-twitter{
            img{
                width: 17px;
                height: 21px;
                filter: invert(15%) sepia(54%) saturate(3654%) hue-rotate(210deg) brightness(98%) contrast(89%);
            }
        }
        .social-icons-youtube{
            img{
                width: 23px;
                height: 34px;
                filter: invert(15%) sepia(54%) saturate(3654%) hue-rotate(210deg) brightness(98%) contrast(89%);
            }
        }

        .row{
            > div:nth-of-type(3){
                h5{
                    text-transform: none;
                }
            }
        }
    }
</style>
